import { bindRumUser, clearRumUser } from '@/utils/rumClient';

/** 登出时递增，丢弃还在等 Bridge 的绑定 */
let syncEpoch = 0;

function parseBridgeUserInfo(raw) {
    if (raw == null) {
        return null;
    }
    try {
        return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch {
        return null;
    }
}

function requestBridgeUserInfo() {
    return new Promise((resolve) => {
        let settled = false;
        const finish = (info) => {
            if (settled) {
                return;
            }
            settled = true;
            resolve(info);
        };

        const onBridgeResult = (result) => {
            const parsed = parseBridgeUserInfo(result);
            if (!parsed) {
                finish(null);
                return;
            }
            const email = String(parsed.email ?? '').trim();
            const customerCode = String(parsed.customerCode ?? '').trim();
            if (!email && !customerCode) {
                finish(null);
                return;
            }
            finish({ email, customerCode });
        };

        window.setTimeout(() => finish(null), 1500);

        if (typeof window.getUserInfo === 'function') {
            window.getUserInfo(onBridgeResult);
            return;
        }
        if (window.easyBridge?.callHandler) {
            window.easyBridge.callHandler('getUserInfo', {}, onBridgeResult);
            return;
        }
        finish(null);
    });
}

async function syncRumUserFromBridge() {
    const epoch = syncEpoch;
    const profile = await requestBridgeUserInfo();
    if (epoch !== syncEpoch || !profile) {
        return;
    }
    bindRumUser(profile.email, profile.customerCode);
}

function isBridgeReady() {
    return typeof window.getUserInfo === 'function' || !!window.easyBridge?.callHandler;
}

/**
 * 桥已在则立刻取用户。
 * `/easybridge.js` 先于业务包执行，旧版 Android/iOS 不派发事件时桥也已经在。
 * 事件留给以后原生在业务包之后才注入的情况。
 */
export function startRumUserBinding() {
    if (typeof window === 'undefined') {
        return;
    }
    let started = false;
    const run = () => {
        if (started || !isBridgeReady()) {
            return;
        }
        started = true;
        syncRumUserFromBridge().catch(() => {});
    };

    run();
    document.addEventListener('WebViewJavascriptBridgeReady', run, { once: true });
}

/** token 刷新后补绑一次（登录可能晚于 Bridge 就绪） */
export function scheduleRumUserSync() {
    syncRumUserFromBridge().catch(() => {});
}

/** 会话失效：取消进行中的绑定并清空 RUM 用户 */
export function clearRumUserBinding() {
    syncEpoch += 1;
    clearRumUser();
}

startRumUserBinding();
